import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActionResult, HelperFunctions } from 'bowman-commons';
import { BowmanCacheService } from 'bowman-cache';
import { FileSaverService } from 'ngx-filesaver';
import { Observable, throwError as observableThrowError } from 'rxjs';
import { catchError, delay, map } from 'rxjs/operators';
import { ExportDto } from 'src/app/import-export/model/export-dto';
import { ImportJsonRequest } from 'src/app/import-export/model/import-json-request';
import { ImportResponse } from 'src/app/import-export/model/import-response';
import { ImportZipRequest } from 'src/app/import-export/model/import-zip-request';
import { SecurityService } from 'src/services/security.service';
import { GuiPluginDto } from 'src/app/shared/gui-plugin.dto';
import { TypeMappingService } from 'src/services/type-mapping.service';


@Injectable({
  providedIn: 'root',
})
export class ManagementService {
  private _mainUrl: string = window.location.pathname+'/api/management/';
  headers: HttpHeaders = new HttpHeaders();
  private _uuid: string;
  constructor(private _http: HttpClient, private _fileSaverService: FileSaverService, private _securityService: SecurityService, private _bowmanCacheService: BowmanCacheService, private _typeMappingService: TypeMappingService) {
    this.headers = new HttpHeaders().set('Content-Type', 'application/json').set('Accept', 'application/json');
    this._uuid = HelperFunctions.uuid();
  }

  public checkImport(object: ImportZipRequest): Observable<ActionResult<Array<string>>> {

    const dataUrl = HelperFunctions.cleanUrl(this._mainUrl + 'zip/checkImport/');
    return this._http.post<ActionResult<Array<string>>>(dataUrl, object, { headers: this.headers }).pipe(catchError(this.handleError));
  }

  public importJson(object: ImportJsonRequest, type: string): Observable<ActionResult<Array<ImportResponse>>> {
    const dataUrl = HelperFunctions.cleanUrl(this._mainUrl + 'json/import/' + type);
    return this._http.post<ActionResult<any>>(dataUrl, object, { headers: this.headers }).pipe(catchError(this.handleError));
  }

  public importZip(object: ImportZipRequest, type: string): Observable<ActionResult<any>> {
    const dataUrl = HelperFunctions.cleanUrl(this._mainUrl + 'zip/import/' + type);
    return this._http.post<ActionResult<any>>(dataUrl, object, { headers: this.headers }).pipe(catchError(this.handleError));
  }
  public export(objectList: Array<ExportDto>, type: string): Observable<any> {
    const dataUrl = HelperFunctions.cleanUrl(this._mainUrl + 'zip/export/' + type);
    return this._http.post<Blob>(dataUrl, objectList, { headers: this.headers, observe: "response" as 'body', responseType: 'blob' as 'json' }).pipe(map((res: any) => {
      let filename: string = (res.headers.get('x-filename'));
      return this._fileSaverService.save(res.body, filename);
    }), catchError(this.handleError));
  }

  public exportSingle(object: ExportDto, type: string): any {
    return this._fileSaverService.save(this.encodeExportDtoToBlob(object), type + '-' + object.name + '.json');
  }


  public encodeExportDtoToBlob(content: ExportDto): Blob {
    let s = content.jsonContent;
    var out = [];
    for (var i = 0; i < s.length; i++) {
      out[i] = s.charCodeAt(i);
    }
    return new Blob([new Uint8Array(out)], {
      type: 'application/octet-stream'
    });
  }



  public refreshIndexStats(): Observable<ActionResult<boolean>> {
    const dataUrl = HelperFunctions.cleanUrl(this._mainUrl + 'refreshIndexStats');
    this._bowmanCacheService.flushServiceCacheByMethod('getTypeMappingOverview');
    return this._http.put<ActionResult<boolean>>(dataUrl, { headers: this.headers }).pipe(delay(1000), catchError(this.handleError));
  }



  public listGuiPlugins(): Observable<ActionResult<{ [name: string]: GuiPluginDto }>> {
    const dataUrl = HelperFunctions.cleanUrl(this._mainUrl + 'guiplugins/list');
    return this._http.get<ActionResult<{ [name: string]: GuiPluginDto }>>(dataUrl, { headers: this.headers }).pipe(catchError(this.handleError));
  }

  public getServerVersion(): Observable<string> {
    const dataUrl = HelperFunctions.cleanUrl(this._mainUrl + 'version');
    let headers = new HttpHeaders().set('Accept', 'application/json');
    return this._http.get<string>(dataUrl, { headers: headers, responseType: 'text' as 'json' }).pipe(map((res: any) => {
      return res
    }), catchError(this.handleError))

  }

  public killActiveSearches(clientIds: Array<string>): Observable<ActionResult<number>> {
    const dataUrl = HelperFunctions.cleanUrl(this._mainUrl + 'killActiveSearches');
    return this._http.post<ActionResult<number>>(dataUrl, clientIds, { headers: this.headers }).pipe(catchError(this.handleError));
  }
    public getApplicationConfigurations(): Observable<Record<string,string>> {
    const dataUrl = HelperFunctions.cleanUrl(this._mainUrl + 'applicationConfigurations');
    return this._http.get<Record<string,string>>(dataUrl, { headers: this.headers }).pipe(catchError(this.handleError));
  }
  private handleError(error: any) {
    let parsedError: any;
    if (error && error.error && error.error.message) {
      parsedError = error.error.message;
    } else if (error && error.message) {
      parsedError = error.message;
    } else if (error && error._body) {
      parsedError = error._body;
    } else {
      parsedError = 'Management Service Error';
    }
    return observableThrowError(parsedError);
  }
}
